import React, { useState, useEffect } from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const UserInformationForm = ({ 
  formData, 
  onFormChange, 
  errors = {},
  disabled = false 
}) => {
  const [localErrors, setLocalErrors] = useState({});

  const validateCedula = (cedula) => {
    const cleanCedula = cedula?.replace(/\D/g, '');
    if (cleanCedula?.length < 7 || cleanCedula?.length > 8) {
      return 'La cédula debe tener entre 7 y 8 dígitos';
    }
    return '';
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex?.test(email)) {
      return 'Ingresa un email válido';
    }
    return '';
  };

  const validatePhone = (phone) => {
    const cleanPhone = phone?.replace(/\D/g, '');
    if (cleanPhone?.length !== 11 || !cleanPhone?.startsWith('04')) {
      return 'Ingresa un número válido (04XX-XXXXXXX)';
    }
    return '';
  };

  const handleInputChange = (field, value) => {
    // Format specific fields
    let formattedValue = value;
    
    if (field === 'cedula') {
      formattedValue = value?.replace(/\D/g, '')?.slice(0, 8);
    } else if (field === 'phone') {
      const cleaned = value?.replace(/\D/g, '');
      if (cleaned?.length <= 11) {
        formattedValue = cleaned?.replace(/(\d{4})(\d{3})(\d{4})/, '$1-$2-$3');
      } else {
        return; // Don't update if too long
      }
    } else if (field === 'name') {
      formattedValue = value?.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
    }

    // Update form data
    onFormChange({ ...formData, [field]: formattedValue });

    // Validate field
    let error = '';
    switch (field) {
      case 'cedula':
        error = validateCedula(formattedValue);
        break;
      case 'email':
        error = validateEmail(formattedValue);
        break;
      case 'phone':
        error = validatePhone(formattedValue?.replace(/\D/g, ''));
        break;
      case 'name':
        error = formattedValue?.trim()?.length < 2 ? 'El nombre debe tener al menos 2 caracteres' : '';
        break;
    }

    setLocalErrors(prev => ({ ...prev, [field]: error }));
  };

  const getDisplayError = (field) => {
    return errors?.[field] || localErrors?.[field] || '';
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-luxury">
      <div className="flex items-center space-x-2 mb-6">
        <div className="p-2 bg-secondary/10 rounded-lg">
          <Icon name="User" size={20} className="text-secondary" />
        </div>
        <div>
          <h3 className="text-lg font-heading font-semibold text-gray-800">
            Información Personal
          </h3>
          <p className="text-sm text-gray-800 font-caption">
            Completa tus datos para procesar la compra
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Cédula de Identidad*"
          type="text"
          placeholder="12345678"
          value={formData?.cedula || ''}
          onChange={(e) => handleInputChange('cedula', e?.target?.value)}
          error={getDisplayError('cedula')}
          required
          disabled={disabled}
          description="Sin puntos ni guiones"
          className="md:col-span-1"
        />

        <Input
          label="Nombre Completo*"
          type="text"
          placeholder="María González"
          value={formData?.name || ''}
          onChange={(e) => handleInputChange('name', e?.target?.value)}
          error={getDisplayError('name')}
          required
          disabled={disabled}
          className="md:col-span-1"
        />

        <Input
          label="Correo Electrónico*"
          type="email"
          placeholder="maria@email.com"
          value={formData?.email || ''}
          onChange={(e) => handleInputChange('email', e?.target?.value)}
          error={getDisplayError('email')}
          required
          disabled={disabled}
          description="Para recibir confirmación del boleto"
          className="md:col-span-1"
        />

        <Input
          label="Teléfono*"
          type="tel"
          placeholder="0412-123-4567"
          value={formData?.phone || ''}
          onChange={(e) => handleInputChange('phone', e?.target?.value)}
          error={getDisplayError('phone')}
          required
          disabled={disabled}
          description="Número de contacto"
          className="md:col-span-1"
        />
      </div>
      <div className="mt-6 p-4 bg-accent/10 border border-accent/20 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Shield" size={16} className="text-accent mt-0.5" />
          <div>
            <h4 className="font-body font-medium text-gray-800 text-sm">
              Información Segura
            </h4>
            <p className="text-xs text-gray-800 font-caption mt-1">
              Tus datos están protegidos y solo se usan para procesar tu compra y contactarte sobre tu boleto.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInformationForm;